export const COLORS = {
  grey_main: "#1C344F",
  grey_600: "#5C6A78",
  grey_400: "#919EAB",
  primary: "#55B653",
};
